module.exports = __webpack_public_path__ + "static/media/svg-5.cc0833dd.svg";